import React from "react";
import { Switch, Route } from "react-router-dom";
import { MapDemoProvider, MapDemoContext, dimportIntro } from "..";
import "./tsp.css";

function Tsp() {
  return (
    <MapDemoProvider>
      <MapDemoContext.Consumer>
        {({ page, setDemo, setEnv }) => {
          setDemo("Tsp");
          setEnv(process.env.NODE_ENV);
          return (
            <Switch>
              <Route
                path="/service-detail/tsp/demo"
                name="Tsp"
                component={dimportIntro(page)}
              />
            </Switch>
          );
        }}
      </MapDemoContext.Consumer>
    </MapDemoProvider>
  );
}

export default Tsp;
